import { normalizeString } from '../functions';

const bankAccountSchema = {
  accountNumber: (accountNumber) => accountNumber,
  accountType: (accountType) => accountType.toLowerCase(),
  bankName: (bankName) =>
    normalizeString({ data: bankName, actions: ['spacing'] }),
  nickname: (nickname) =>
    normalizeString({ data: nickname, actions: ['spacing'] }),
  routingNumber: (routingNumber) => routingNumber,
  isCommissionAccount: (isCommissionAccount) => isCommissionAccount,
  isContributionSource: (isContributionSource) => isContributionSource,
};

export default bankAccountSchema;
